export const environment = {
  production: true,
  isSandbox: true,
  url: "https://api.teamapp.staging.mazak.com.pl/api/",
  hmr: false,
  developmentAccounts: [],
};